import React from 'react';
import { Box } from '@mui/material';

const FILTERS = ['week', 'month', 'year'];

const FilterToggle = ({ value, onChange, sx }) => (
  <Box sx={{ display: 'flex', gap: 1, ...sx }}>
    {FILTERS.map((f) => {
      const active = value === f;
      return (
        <Box
          key={f}
          component="button"
          onClick={() => onChange(f)}
          sx={{
            px: 3,
            py: 1,
            borderRadius: '29px',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'Heebo',
            fontWeight: 600,
            fontSize: 14,
            textTransform: 'capitalize',
            transition: 'all 0.2s',
            background: active
              ? 'linear-gradient(180deg, #065F46 0%, #0D7B5C 100%)'
              : '#f3f4f6',
            color: active ? '#fff' : '#6b7280',
            boxShadow: active ? '1px 2px 12px 0px rgba(6,95,70,0.18)' : 'none',
            '&:hover': { opacity: 0.85 },
          }}
        >
          {f.charAt(0).toUpperCase() + f.slice(1)}
        </Box>
      );
    })}
  </Box>
);

export default FilterToggle;
